import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const DELETE_STATEMENT_OPERATION = gql`
  mutation DeleteStatementOperation($deletedStatementOperationUuid: ID!, $valueDate: Date!) {
    deleteStatementOperation(
      deletedStatementOperationUuid: $deletedStatementOperationUuid
      valueDate: $valueDate
    )
  }
`;

export const useDeleteStatementOperation = () => {
  const [deleteStatementOperation, { loading, error, data }] = useMutation(DELETE_STATEMENT_OPERATION);

  return {
    deleteStatementOperation,
    loading,
    error,
    data: data?.deleteStatementOperation,
  };
};

export default useDeleteStatementOperation;
